module.exports = __webpack_public_path__ + "static/mr-concert-performance-21-58c7a71508bb7f2f1551be83c29aaed1.jpg";